import { useTeam } from "~/contexts/TeamProvider";

import { usePolling } from "./usePolling";

/**
 * Rechecks the current team for a while after a Stripe action (a saved
 * card, a paid invoice): its webhooks change the team a few seconds later,
 * and the SubscriptionsChannel may miss it (e.g. during the page load
 * Stripe comes back with). It polls only while `isWaiting` holds, so it
 * stops as soon as the expected change is in.
 */
export function useTeamPolling(isWaiting: boolean) {
  const { refetchTeam } = useTeam();

  return usePolling(isWaiting, () => void refetchTeam());
}
